import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function initHorizontalSections() {
    const containers = document.querySelectorAll('[data-horizontal-sections]');
    if (containers.length === 0) return;

    // Helper function to setup the scroll trigger
    const setupHorizontalScroll = (container) => {
        const track = container.querySelector('.horizontal-sections-track');
        if (!track) return;
        
        // Calculate the distance to scroll
        function getScrollAmount() {
            let trackWidth = track.scrollWidth;
            return -(trackWidth - container.offsetWidth);
        }

        const progressBar = container.querySelector('.horizontal-sections-progress-bar');
        
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: container,
                start: "top top",
                pin: true,
                pinSpacing: true,
                scrub: 1,
                // Multiply by a factor to make the scroll slower (user scrolls more vertical pixels for the same horizontal distance)
                end: () => "+=" + ((track.scrollWidth - container.offsetWidth) * 2),
                markers: false,
                refreshPriority: 1 // Important: Calculate this before other triggers
            }
        });

        // Move the track
        // Added delays (padding) at start and end to prevent content from being cut off too quickly during scroll
        const scrollDuration = 10;
        const startDelay = 1;
        const endDelay = 1;

        tl.to(track, { 
            x: 0, 
            duration: startDelay, 
            ease: "none" 
        })
        .to(track, {
            x: getScrollAmount,
            ease: "none",
            duration: scrollDuration
        })
        .to(track, {
            x: getScrollAmount,
            duration: endDelay,
            ease: "none"
        });

        // Animate progress bar if it exists
        if (progressBar) {
            tl.fromTo(progressBar, 
                { width: "0%" },
                { 
                    width: "100%", 
                    ease: "none",
                    duration: scrollDuration + startDelay + endDelay
                },
                0 // Start at the beginning of the timeline
            );
        }
    };

    containers.forEach(container => {
        // If it is the specific property features section, restrict to desktop
        if (container.classList.contains('property-horizontal-features')) {
            ScrollTrigger.matchMedia({
                "(min-width: 992px)": function() {
                    setupHorizontalScroll(container);
                    
                    // Cleanup callback
                    return () => {
                        // GSAP handles cleanup mostly, but we ensure styles are cleared if needed
                        const track = container.querySelector('.horizontal-sections-track');
                        if(track) gsap.set(track, { clearProps: "all" });
                    };
                }
            });
        } else {
            // All other sections behave normally (always horizontal)
            // Or we could wrap this in a saveStyles to be safe generally
            ScrollTrigger.saveStyles(container.querySelector('.horizontal-sections-track'));
            setupHorizontalScroll(container);
        }
    });
}
